var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.mode === "DESIGN"
        ? [
            !_vm.expanding
              ? _c("el-input", {
                  staticClass: "max-width disabled-box",
                  attrs: {
                    "suffix-icon": "el-icon-arrow-down",
                    size: "small",
                    placeholder: _vm.placeholder,
                  },
                })
              : _c(
                  "el-radio-group",
                  {
                    staticClass: "radio-group-box disabled-box",
                    model: {
                      value: _vm._value,
                      callback: function ($$v) {
                        _vm._value = $$v
                      },
                      expression: "_value",
                    },
                  },
                  _vm._l(_vm.options, function (op, index) {
                    return _c(
                      "el-radio",
                      { key: index, attrs: { label: op } },
                      [_vm._v(_vm._s(op))]
                    )
                  }),
                  1
                ),
          ]
        : [
            !_vm.readerMode || _vm.perm === "E"
              ? [
                  !_vm.expanding
                    ? _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: _vm.placeholder,
                            disabled: _vm.perm === "R",
                          },
                          model: {
                            value: _vm._value,
                            callback: function ($$v) {
                              _vm._value = $$v
                            },
                            expression: "_value",
                          },
                        },
                        _vm._l(_vm.options, function (op, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: op, label: op },
                          })
                        }),
                        1
                      )
                    : _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-box",
                          attrs: { disabled: _vm.perm === "R" },
                          model: {
                            value: _vm._value,
                            callback: function ($$v) {
                              _vm._value = $$v
                            },
                            expression: "_value",
                          },
                        },
                        _vm._l(_vm.options, function (op, index) {
                          return _c(
                            "el-radio",
                            { key: index, attrs: { label: op } },
                            [_vm._v(_vm._s(op))]
                          )
                        }),
                        1
                      ),
                ]
              : [
                  _c("div", {
                    staticClass: "form-item-text",
                    domProps: { textContent: _vm._s(_vm._value) },
                  }),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }